import {all, delay, fork, put, takeLatest} from "redux-saga/effects";
import AlgoliaService from "../../services/AlgoliaService";
import {GET_CARS} from "../constants/Cars";
import {getCarsSuccess} from "../actions/Cars";

export function* getCars(){
  yield takeLatest(GET_CARS, function* ({page, perPage, search}){
    try {
      if(search && page === 1)
        yield delay(1000)
      const res = yield AlgoliaService.getCars({
        query: search,
        hitsPerPage: perPage,
        page: (page - 1)
      })

      const skip = perPage * (page - 1)
      const from = skip + 1
      const to = (skip + perPage > res.data.nbHits) ? res.data.nbHits : skip + perPage
      yield put(getCarsSuccess(res.data.hits, res.data.nbHits, from, to))
    } catch (err){
      console.log(err)
      // Request new search token and perform the saga
    }
  })
}

export default function* carsSaga() {
  yield all([
    fork(getCars),
  ]);
}